import { env } from '../env/env';
const C2FO_API_GATEWAY = env.getString('GATEWAY_URL');
export const suggestedRateApiConfig = {
    SUGGESTED_RATE_API_URL: C2FO_API_GATEWAY ? `${C2FO_API_GATEWAY}/api/public/graphql` : 'http://localhost:9990/graphql',
};
//# sourceMappingURL=suggestedRateApiConfig.js.map